// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ApprovalPage_tableWrapper__6C8wH","root":"ApprovalPage_root__5Xp9U","wrap":"ApprovalPage_wrap__j7GOJ"};